import { TableResponse } from "..";

export enum ProductStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum ProductTypeEnum {
  wallet = "wallet",
  other_product = "other_product",
}

export interface Product {
  sku: string;
  product_name: string;
  vendor?: string;
  description?: string;
  image_url?: string;
  flexible_price: boolean;
  price: number;
  cost: number;
  type: ProductTypeEnum;
  manage_inventory: boolean;
  quantity: number;
  income_category_id: string;
  sale_tax_id: number;
  status: ProductStatus;
  id?: number;
}

export type ProductTable = TableResponse<Product>;